// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  margin-bottom: 30px;
  width: 80%;
  padding: 22px 10px 20px 0px;
}

.title {
  font-size: 26px;
  font-family: var(--font-tusker);
  position: relative;
  margin-bottom: 50px;
  max-width: 290px;
}
.title::after {
  content: "";
  position: absolute;
  bottom: -9px;
  left: 0;
  width: 100%;
  height: 5px;
  background-image: url('separator_menu_modal.svg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.info-block {
  margin-bottom: 35px;
}

.subtitle {
  color: #521340;
  font-family: AppFontBlack;
  font-size: 16px;
}

.info {
  color: #521340;
  font-family: AppFont600;
  font-size: 14px;
  letter-spacing: 0.14px;
  line-height: 23.24px;
}

.hours-modal-wrapper {
  padding: 25px 22px;
  font-size: 14px;
}
@media screen and (max-width: 400px) {
  .hours-modal-wrapper {
    padding: 25px 15px;
  }
}
@media screen and (max-width: 400px) {
  .hours-modal-wrapper .fees span {
    font-size: 9px;
  }
}
.hours-modal-wrapper .first-fee {
  margin-bottom: 10px;
}
.hours-modal-wrapper .icon {
  width: 20px;
  margin-right: 9px;
}
.hours-modal-wrapper .first {
  margin: 35px 0 20px;
}
.hours-modal-wrapper .time {
  display: block;
}
@media screen and (max-width: 320px) {
  .hours-modal-wrapper .time {
    font-size: 12px;
  }
}
.hours-modal-wrapper .info-row:first-child {
  margin-top: 25px;
  margin-right: 25px;
}
@media (min-width: 991px) {
  .hours-modal-wrapper .info-row:first-child {
    margin-top: 35px;
  }
}
.hours-modal-wrapper .info-row .name {
  width: 130px;
  margin: 0;
}
@media (min-width: 991px) {
  .hours-modal-wrapper .info-row .name {
    margin-bottom: 15px;
  }
}
.hours-modal-wrapper .info-row .info {
  font-size: 13px;
  padding: 0;
}
.hours-modal-wrapper .info-row .info p {
  margin: 0 0 6px 0;
}
.hours-modal-wrapper .bottom-start {
  position: absolute;
  left: 0;
  bottom: -145px;
  height: 300px;
  width: 103px;
}

.time-title {
  margin-bottom: 8px;
}

a {
  font-family: AppFont, sans-serif;
  color: var(--ion-color-tertiary) !important;
  text-decoration: underline;
}

.tertiary {
  color: var(--ion-color-tertiary) !important;
}

ion-footer .footer-text {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 64px;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.05);
  flex-wrap: nowrap;
  overflow: auto;
}
ion-footer .footer-text .link {
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  margin: 0;
  border-right-width: 2px;
  border-right-style: solid;
  border-image: linear-gradient(180deg, rgb(255, 255, 255) 20%, rgb(82, 19, 64) 20%, rgb(82, 19, 64) 85%, rgb(255, 255, 255) 85%);
  border-image-slice: 1;
  color: #521340;
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 121.4%; /* 19.424px */
  letter-spacing: 0.32px;
  text-decoration-line: underline;
  text-underline-offset: 0.2em;
  text-transform: capitalize;
}
ion-footer .footer-text .link:last-child {
  border-right: none;
}

ion-footer .footer-text {
  display: flex;
  align-items: center;
  height: 64px;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.05);
  flex-wrap: nowrap;
  overflow: auto;
}
ion-footer .footer-text .link {
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  margin: 0;
  border-right-width: 2px;
  border-right-style: solid;
  border-image: linear-gradient(180deg, rgb(255, 255, 255) 20%, rgb(82, 19, 64) 20%, rgb(82, 19, 64) 85%, rgb(255, 255, 255) 85%);
  border-image-slice: 1;
  color: #521340;
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 121.4%; /* 19.424px */
  letter-spacing: 0.32px;
  text-decoration-line: underline;
  text-underline-offset: 0.2em;
  text-transform: capitalize;
}
ion-footer .footer-text .link:last-child {
  border-right: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/working-hours-modal/working-hours-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;EACA,UAAA;EACA,2BAAA;AADD;;AAGA;EACC,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAAD;AAEC;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,iDAAA;EACA,4BAAA;EACA,kCAAA;EACA,sBAAA;AAAF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACC,cAAA;EACA,yBAAA;EACA,eAAA;AADD;;AAIA;EACC,cAAA;EACA,uBAAA;EACA,eAAA;EACA,sBAAA;EACC,oBAAA;AADF;;AAIA;EACC,kBAAA;EACA,eAAA;AADD;AAGC;EAJD;IAKE,kBAAA;EAAA;AACF;AAIG;EADD;IAEE,cAAA;EADF;AACF;AAWC;EACC,mBAAA;AATF;AAYC;EACC,WAAA;EACA,iBAAA;AAVF;AAaC;EACC,mBAAA;AAXF;AAkBC;EACC,cAAA;AAhBF;AAiBE;EAFD;IAGE,eAAA;EAdD;AACF;AAkBE;EACC,gBAAA;EACA,kBAAA;AAhBH;AC9EE;ED4FA;IAIE,gBAAA;EAdF;AACF;AAuBE;EACC,YAAA;EACA,SAAA;AArBH;ACvFE;ED0GA;IAIE,mBAAA;EAnBF;AACF;AAsBE;EACC,eAAA;EACA,UAAA;AApBH;AAsBG;EACC,iBAAA;AApBJ;AA0BC;EACC,kBAAA;EACA,OAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;AAxBF;;AA4BA;EACE,kBAAA;AAzBF;;AA4BA;EACC,gCAAA;EACA,2CAAA;EACA,0BAAA;AAzBD;;AA2BA;EACC,2CAAA;AAxBD;;AA4BC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,gDAAA;EACA,iBAAA;EACA,cAAA;AAzBF;AA0BE;EACC,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,+HAAA;EAOA,qBAAA;EAED,cAAA;EAEA,wBAAA;EACA,eAAA;EACA,mBAAA,EAAA,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,4BAAA;EACC,0BAAA;AAhCH;AAmCG;EACC,kBAAA;AAjCJ;;AAyCC;EACC,aAAA;EAEA,mBAAA;EACA,YAAA;EACA,gDAAA;EACA,iBAAA;EACA,cAAA;AAvCF;AAwCE;EACC,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,+HAAA;EAOA,qBAAA;EAED,cAAA;EAEA,wBAAA;EACA,eAAA;EACA,mBAAA,EAAA,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,4BAAA;EACC,0BAAA;AA9CH;AAiDG;EACC,kBAAA;AA/CJ","sourcesContent":["@import '../../../theme/mixins';\n\n.logo {\n\tmargin-bottom: 30px;\n\twidth: 80%;\n\tpadding: 22px 10px 20px 0px;\n}\n.title {\n\tfont-size: 26px;\n\tfont-family: var(--font-tusker);\n\tposition: relative;\n\tmargin-bottom: 50px;\n\tmax-width: 290px;\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tbottom: -9px;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 5px;\n\t\tbackground-image: url('../../../assets/tabilo/separator_menu_modal.svg');\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-position: center center;\n\t\tbackground-size: cover;\n\t}\n}\n\n.info-block {\n  margin-bottom: 35px;\n}\n\n.subtitle {\n\tcolor: #521340;\n\tfont-family: AppFontBlack;\n\tfont-size: 16px;\n}\n\n.info {\n\tcolor: #521340;\n\tfont-family: AppFont600;\n\tfont-size: 14px;\n\tletter-spacing: 0.14px;\n  line-height: 23.24px;\n}\n\n.hours-modal-wrapper {\n\tpadding: 25px 22px;\n\tfont-size: 14px;\n\n\t@media screen and (max-width: 400px) {\n\t\tpadding: 25px 15px;\n\t}\n\n\t.fees {\n\t\tspan {\n\t\t\t@media screen and (max-width: 400px) {\n\t\t\t\tfont-size: 9px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.open-time {\n\t\t// @include desktop {\n\t\t// \tdisplay: flex;\n\t\t// }\n\t}\n\n\t.first-fee {\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.icon {\n\t\twidth: 20px;\n\t\tmargin-right: 9px;\n\t}\n\n\t.first {\n\t\tmargin: 35px 0 20px;\n\t\t// @include desktop {\n\t\t// \tmargin: 35px 0 20px;\n\t\t// \tflex-direction: column;\n\t\t// }\n\t}\n\n\t.time {\n\t\tdisplay: block;\n\t\t@media screen and (max-width: 320px) {\n\t\t\tfont-size: 12px;\n\t\t}\n\t}\n\n\t.info-row {\n\t\t&:first-child {\n\t\t\tmargin-top: 25px;\n\t\t\tmargin-right: 25px;\n\t\t\t@include desktop {\n\t\t\t\tmargin-top: 35px;\n\t\t\t}\n\t\t}\n\n\t\t// &:last-child {\n\t\t// \t@include desktop {\n\t\t// \t\tmargin-left: 30px;\n\t\t// \t}\n\t\t// }\n\n\t\t.name {\n\t\t\twidth: 130px;\n\t\t\tmargin: 0;\n\t\t\t@include desktop {\n\t\t\t\tmargin-bottom: 15px;\n\t\t\t}\n\t\t}\n\n\t\t.info {\n\t\t\tfont-size: 13px;\n\t\t\tpadding: 0;\n\n\t\t\tp {\n\t\t\t\tmargin: 0 0 6px 0;\n\t\t\t}\n\n\t\t}\n\t}\n\n\t.bottom-start {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tbottom: -145px;\n\t\theight: 300px;\n\t\twidth: 103px;\n\t}\n}\n\n.time-title {\n  margin-bottom: 8px;\n}\n\na {\n\tfont-family: AppFont, sans-serif;\n\tcolor: var(--ion-color-tertiary) !important;\n\ttext-decoration: underline;\n}\n.tertiary {\n\tcolor: var(--ion-color-tertiary) !important;\n}\n\nion-footer {\n\t.footer-text {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\theight: 64px;\n\t\tbox-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.05);\n\t\tflex-wrap: nowrap;\n\t\toverflow:auto;\n\t\t.link {\n\t\t\twidth: fit-content;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\t\t\tpadding: 8px;\n\t\t\tmargin: 0;\n\t\t\tborder-right-width: 2px;\n\t\t\tborder-right-style: solid;\n\t\t\tborder-image: linear-gradient(\n\t\t\t\t180deg,\n\t\t\t\trgba(255, 255, 255, 1) 20%,\n\t\t\t\trgba(82, 19, 64, 1) 20%,\n\t\t\t\trgba(82, 19, 64, 1) 85%,\n\t\t\t\trgba(255, 255, 255, 1) 85%\n\t\t\t);\n\t\t\tborder-image-slice: 1;\n\t\n\t\tcolor: #521340;\n\t\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 16px;\n\t\tline-height: 121.4%; /* 19.424px */\n\t\tletter-spacing: 0.32px;\n\t\ttext-decoration-line: underline;\n\t\ttext-underline-offset: 0.2em; \n\t\t\ttext-transform: capitalize;\n\t\n\t\n\t\t\t&:last-child {\n\t\t\t\tborder-right: none;\n\t\t\t}\n\t\t}\n\t}\n\n}\n\nion-footer {\n\t.footer-text {\n\t\tdisplay: flex;\n\n\t\talign-items: center;\n\t\theight: 64px;\n\t\tbox-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.05);\n\t\tflex-wrap: nowrap;\n\t\toverflow:auto;\n\t\t.link {\n\t\t\twidth: fit-content;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\t\t\tpadding: 8px;\n\t\t\tmargin: 0;\n\t\t\tborder-right-width: 2px;\n\t\t\tborder-right-style: solid;\n\t\t\tborder-image: linear-gradient(\n\t\t\t\t180deg,\n\t\t\t\trgba(255, 255, 255, 1) 20%,\n\t\t\t\trgba(82, 19, 64, 1) 20%,\n\t\t\t\trgba(82, 19, 64, 1) 85%,\n\t\t\t\trgba(255, 255, 255, 1) 85%\n\t\t\t);\n\t\t\tborder-image-slice: 1;\n\t\n\t\tcolor: #521340;\n\t\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 16px;\n\t\tline-height: 121.4%; /* 19.424px */\n\t\tletter-spacing: 0.32px;\n\t\ttext-decoration-line: underline;\n\t\ttext-underline-offset: 0.2em; \n\t\t\ttext-transform: capitalize;\n\t\n\t\n\t\t\t&:last-child {\n\t\t\t\tborder-right: none;\n\t\t\t}\n\t\t}\n\t}\n\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
